import React, { useState } from "react";
import emailjs from "emailjs-com";
import Swal from "sweetalert2";
import "./FormStyle.css";



export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    tel: "",
    subj: "",
    msg: "",
  });
  

        

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

   

  const handleSubmit = (e) => {
    e.preventDefault();
  


    

    emailjs
      .send(
        "service_jqz3vmf",   // from EmailJS
        "template_mh6fdzg",  // from EmailJS
        formData,
        "DKjPo1A1ZZh5kaA_P"    // from EmailJS
      )
      .then(
        (response) => {
          // alert("Message sent successfully!");
          Swal.fire(
            "success",
            "Thank you for Contacting us!",
            "success",
                    );
          // console.log("SUCCESS!", response.status, response.text);
        },
        (error) => {
          Swal.fire({
          icon: "error",
          title: "Failed to send message.",
          text: "Something went wrong!",
          });      
          // alert("Failed to send message.");
          // console.error("FAILED...", error);
        }
      );

  };

  //  const handleClick = () =>{
  //       Swal.fire({
  //     title: "Are you sure You want to Send?",
  //     showDenyButton: true,
  //     showCancelButton: true,
  //     confirmButtonText: "Send",
  //     denyButtonText: `Don't send`
  //   }).then((submit) => {
  //     /* Read more about isConfirmed, isDenied below */
  //     if (submit.isConfirmed) {
  //       Swal.fire({
  //       position: "top-end",
  //       icon: "success",
  //       title: "Your been Processed",
  //       showConfirmButton: false,
  //       timer: 2000
  //     });
  //     } else if (submit.isDenied) {
  //       Swal.fire("Message not Sent", "", "info");
  //     }
  //   });
  // };

  return (
    <form onSubmit={handleSubmit} className="Form">
      <input
        type="text"
        name="name"
        placeholder="Your Name"
        value={formData.name}
        onChange={handleChange}
        className="w-full p-2 border mb-2 rounded"
        required
      />
      <input
        type="email"
        name="email"
        placeholder="Enter Valid Email"
        value={formData.emailadd}
        onChange={handleChange}
        className="w-full p-2 border mb-2 rounded"
        required
      />
      <input
        type="tel"
        name="tel"
        placeholder="Your Phone"
        value={formData.phone}
        onChange={handleChange}
        className="w-full p-2 border mb-2 rounded"
      />
      <input
        type="text"
        name="subj"
        placeholder="Subject"
        value={formData.subj}
        onChange={handleChange}
        className="w-full p-2 border mb-2 rounded"
        required
      />
      <textarea
        name="msg"
        rows="6"
        placeholder="Your Message"
        value={formData.msg}
        onChange={handleChange}
        className="w-full p-2 border mb-2 rounded"
        required
      />
      <button
        type="submit"
        className="btn"
        // onClick={handleClick}
      >
        Send
      </button>
    </form>
  );
}
